var promises = [];
export var importFidel = function (scriptAttributes) {
    var promise = new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://resources.fidel.uk/sdk/js/v2/fidel.js";
        Object.keys(scriptAttributes).map(function (attribute) {
            var value = scriptAttributes[attribute];
            if (attribute && value) {
                script.setAttribute(attribute, value);
            }
        });
        script.addEventListener("load", function () { return resolve(script); }, false);
        script.addEventListener("error", function () { return reject(script); }, false);
        document.body.appendChild(script);
    });
    promises.push(promise);
    return promise;
};
export var removeFidel = function () {
    promises.map(function (promise, index) {
        promise
            .then(function (script) {
            window.Fidel.closeForm();
            document.body.removeChild(script);
            promises.splice(index, 1);
        })
            .catch(function (script) {
            document.body.removeChild(script);
            promises.splice(index, 1);
        });
    });
    return Promise.all(promises);
};
